module.exports = __webpack_public_path__ + "assets/img/ios-landscape1.224d2b5.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/ios-landscape1.png
// module id = CQ4N
// module chunks = 50